import { render, staticRenderFns } from "./public-header.vue?vue&type=template&id=beece096&scoped=true&"
import script from "./public-header.vue?vue&type=script&lang=js&"
export * from "./public-header.vue?vue&type=script&lang=js&"
import style0 from "./public-header.vue?vue&type=style&index=0&id=beece096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beece096",
  null
  
)

export default component.exports